<template>
  <v-select :items="phases" v-model="currentPhase" label="Phase filter" />
</template>

<script setup>
import { computed } from 'vue';
import { colors, labels } from '../phases'

const phases = Object
  .entries(colors)
  .map(([key]) => ({
    text: labels[key] || key,
    value: key,
  }))

const props = defineProps({
  value: { type: String, required: true },
})

const emit = defineEmits(['input'])

const currentPhase = computed({
  get() {
    return props.value
  },
  set(value) {
    emit('input', value)
  }
})
</script>
